/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { fetchInitialConditions } from '../../../redux/reducers/PAFAA010';
import { postPAFAA010list, postPAJAF010 } from '../../../services/Api';
import Dropdown from '../../../shared/components/Dropdown';
import Loader from '../../../shared/components/Loader';
import Pagination from '../../../shared/components/Pagination';
import PopupSendMail from '../../../shared/components/PopupSendMail';
import ResumeItem from '../../../shared/components/ResumeItem';
import SideNav from '../../../shared/components/SideNav';
import { decodeToken, getDropdownValue } from '../../../utils';
import PopupPAJAF010 from './PopupPAJAF010';

const PAJAF010 = () => {
    const [loading, setLoading] = useState(false);

    const [results, setResults] = useState([]);
    const [resultsStTab, setResultsStTab] = useState([]);
    const [selectRecruits, setSelectRecruits] = useState([]);
    const [infoRecruit, setInfoRecruit] = useState([]);
    const [recruitSeq, setRecruitSeq] = useState(0);
    const [isFilter, setIsFilter] = useState(true);
    const [receiver, setReceiver] = useState({ id: '', name: '' });

    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const pageStTab = Number(searchParams.get('pageSt')) || 1;
    const [pages, setPages] = useState({});
    const [pagesFirstTab, setPagesFirstTab] = useState({});
    const [index, setIndex] = useState(0);
    const [condition, setCondition] = useState(0);
    const savedConditions = useSelector(({ PAFAA010 }) => PAFAA010.savedPAFAA010Conditions || []);
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [sortBy, setSortBy] = useState('ModDate');
    const [sortByStTab, setSortByStTab] = useState('ModDate');

    const [checkedValues, setCheckedValues] = useState({});
    const [checkedLikeRightValues, setCheckedLikeRightValues] = useState({});
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [resumeRegion, setResumeRegion] = useState({});
    const [popupSendMailOpen, setPopupSendMailOpen] = useState(false);
    const [activePopup, setActivePopup] = useState(false);
    const dispatch = useDispatch();

    const [itemSearch, setItemSearch] = useState([
        { label: '채용공고매칭', active: 1, disabled: 0, showData: 0 },
        { label: '매칭조건 1', active: 0, disabled: 0, showData: 1 },
        { label: '매칭조건 2', active: 0, disabled: 0, showData: 1 },
        { label: '매칭조건 3', active: 0, disabled: 0, showData: 1 },
    ]);

    const getOptions = (name) => {
        const options = {
            SelectRecruit:
                selectRecruits && selectRecruits.length > 0
                    ? selectRecruits.map((option) => ({ option: option.title, value: option.seq }))
                    : [{ option: '게재중인 공고 없습니다.', value: '' }],
        };
        return options[name];
    };

    // dropdown
    const handleOptionChange = (selectedValue, name) => {
        switch (name) {
            case 'sortBy':
                index === 0 ? setSortByStTab(selectedValue) : setSortBy(selectedValue);
                break;
            case 'recruitSeq':
                setRecruitSeq(selectedValue);
                break;
            default:
                setCheckedValues((checkedValues) => getDropdownValue(checkedValues, name, selectedValue));
                break;
        }
    };

    const getListData = async () => {
        setLoading(true);
        const startDateFormat = startDate === '' ? null : moment(startDate).format('yyyy-MM-DD');
        const endDateFormat = endDate === '' ? null : moment(endDate).format('yyyy-MM-DD');
        let optionLike = checkedValues && Object.keys(checkedValues || {}).length === 0 ? null : checkedValues;
        const optionLikeRight = Object.keys(checkedLikeRightValues || {}).length === 0 ? null : checkedLikeRightValues;
        const region = Object.keys(resumeRegion || {}).length === 0 ? null : resumeRegion;

        const filteredRegion = region
            ? Object.fromEntries(Object.entries(region).filter(([key]) => checkedValues?.RegionSi?.includes(key)))
            : null;

        let optionLikeCopy = { ...optionLike };
        delete optionLikeCopy.RegionSi;
        delete optionLikeCopy.RegionGu;

        postPAFAA010list({
            optionLike,
            optionLikeRight,
            resumeRegion: filteredRegion,
            startDate: startDateFormat,
            endDate: endDateFormat,
            size: 10,
            page,
            sortBy,
        })
            .then(({ data }) => {
                setResults(data.data.list);
                setPages(data.info);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };
    const getListDataStTab = async () => {
        setLoading(true);
        await postPAJAF010({
            sortBy: sortByStTab,
            page: pageStTab,
            ...(recruitSeq !== 0 && {
                options: {
                    Seq: [recruitSeq],
                },
            }),
        })
            .then(async ({ data }) => {
                setResultsStTab(data.data.list);
                setPagesFirstTab(data.info);
                setSelectRecruits(data.data.recruits);
                setInfoRecruit(data.data.InfoRecruit);
                if (data.data.list === null) {
                    setItemSearch((prevData) =>
                        prevData.map((item, index) => ({
                            ...item,
                            active: index === 0 ? 1 : 0,
                        })),
                    );
                    setIsFilter(true);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const handleChange = (e) => {
        const itemIndex = Number(e.currentTarget.dataset.index);
        const isShow = Number(e.currentTarget.dataset.show);

        setItemSearch((prevData) =>
            prevData.map((item, index) => ({
                ...item,
                active: itemIndex === index ? 1 : 0,
            })),
        );
        setCondition(isShow);
        setIsFilter(itemIndex === 0);
        setIndex(itemIndex);
        if (itemIndex === 0) {
            getListDataStTab();
        }
    };

    useEffect(() => {
        // fix lỗi chọn tab chưa thêm điều kiện đã getListData
        getListData();
    }, [checkedValues, checkedLikeRightValues, startDate, endDate, resumeRegion]);

    const closePopup = () => {
        setPopupSendMailOpen(false);
    };

    const handlePopupClose = () => {
        setActivePopup(false);
        setSearchParams(1);
    };

    const handleSelectSavedCondition = (index) => {
        const item = savedConditions[index - 1];
        if (!item) return;

        const { checkedStoreValues, checkedLikeRightStoreValues, startStoreDate, endStoreDate, resumeRegionStore } =
            item;

        setCheckedValues(checkedStoreValues);
        setCheckedLikeRightValues(checkedLikeRightStoreValues);
        setStartDate(startStoreDate);
        setEndDate(endStoreDate);
        setResumeRegion(resumeRegionStore);
    };

    useEffect(() => {
        dispatch(fetchInitialConditions());
    }, [dispatch]);

    useEffect(() => {
        if (index !== null) {
            handleSelectSavedCondition(index);
        }
        // eslint-disable-next-line
    }, [index]);

    useEffect(() => {
        if (!activePopup) {
            handleSelectSavedCondition(index);
        }
        // eslint-disable-next-line
    }, [activePopup]);

    useEffect(() => {
        if (page || sortBy) {
            getListData();
        }
        // eslint-disable-next-line
    }, [page, sortBy]);

    useEffect(() => {
        setItemSearch((prevData) =>
            prevData.map((item, index) => ({
                ...item,
                disabled: index < savedConditions.length + 1 ? 0 : 1,
            })),
        );
    }, [savedConditions]);

    useEffect(() => {
        if (condition === 0) {
            getListDataStTab();
        }
        // eslint-disable-next-line
    }, [pageStTab, sortByStTab, recruitSeq]);

    useEffect(() => {
        if (!resultsStTab) {
            setIndex(0);
            setCondition(0);
            setIsFilter(false);
        }
    }, [resultsStTab]);

    useEffect(() => {
        getListDataStTab();
    }, []);

    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume">
                            <div className="resume__inner">
                                <h3 className="resume__tit">추천 인재</h3>
                                <div className="rsm-stt w850px">
                                    {/* <div className="rsm-mng">
                                        <div className="rsm-mng__btbx">
                                            <button
                                                type="button"
                                                id="mtchPopOpen"
                                                className="rsm-mng__btn"
                                                onClick={() => setActivePopup(true)}
                                            >
                                                추천 인재 조건 설정
                                            </button>
                                        </div>
                                    </div> */}

                                    <div className="mtch">
                                        <div className="groupDropDowns">
                                            <div className="d-flex align-items-center gap-2 w100">
                                                <div className="dropDowns w100">
                                                    {selectRecruits !== null ? (
                                                        <Dropdown
                                                            options={getOptions('SelectRecruit')}
                                                            placeholder={selectRecruits[0]?.title}
                                                            name="recruitSeq"
                                                            value={recruitSeq}
                                                            onChange={handleOptionChange}
                                                            className="form-select-container--ver2 maxContents w100"
                                                        />
                                                    ) : (
                                                        <Dropdown
                                                            placeholder="게재중인 공고 없습니다."
                                                            name="recruitSeq"
                                                            value={''}
                                                            className="form-select-container--ver2 maxContents w100"
                                                            style={{ width: '100%' }}
                                                            disabled
                                                        />
                                                    )}
                                                </div>
                                                {/* <div className="mtch__block col_4">
                                                    {itemSearch.map((item, index) => {
                                                        return (
                                                            <Link
                                                                className={`mtch__cnd h40 ${item.active ? 'active' : ''
                                                                    }`}
                                                                onClick={handleChange}
                                                                key={index}
                                                                data-index={index}
                                                                data-show={item.showData}
                                                            >
                                                                {`${item.label}`}
                                                            </Link>
                                                        );
                                                    })}
                                                </div> */}
                                            </div>
                                            {/* <div className="dropDowns">
                                                <Dropdown
                                                    placeholder=""
                                                    options={[
                                                        { value: 'AddDate', option: '등록일순' },
                                                        { value: 'ModDate', option: '업데이트순' },
                                                    ]}
                                                    name="sortBy"
                                                    value={index === 0 ? sortByStTab : sortBy}
                                                    onChange={handleOptionChange}
                                                    className="form-select-container--ver2"
                                                />
                                            </div> */}
                                        </div>
                                        {condition === 0 && (
                                            <ul
                                                className={`mtch__state ${!infoRecruit?.length > 0
                                                    ? 'justify-content-center align-items-center'
                                                    : ''
                                                    }`}
                                            >
                                                {infoRecruit && infoRecruit?.length > 0 ? (
                                                    infoRecruit?.map((item, idx) => (
                                                        <React.Fragment key={`condition-${item?.seq || idx}`}>
                                                            {item.recruitClass && <li>{item.recruitClass}</li>}
                                                            {item.recruitLicense && <li>{item.recruitLicense}</li>}
                                                            {item.recruitForm && <li>{item.recruitForm}</li>}
                                                            {item.recruitPosition && <li>{item.recruitPosition}</li>}
                                                            {item.recruitPay && <li>{item.recruitPay}</li>}
                                                            {item.recruitGrade && <li>{item.recruitGrade}</li>}
                                                            {(item.regionSiName || item.regionGuName) && (
                                                                <li>
                                                                    {item.regionSiName}
                                                                    {item.regionGuName && ` > ${item.regionGuName}`}
                                                                </li>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                ) : (
                                                    <li>검색조건 없습니다</li>
                                                )}
                                            </ul>
                                        )}
                                        {condition !== 0 && (
                                            <ul
                                                className={`mtch__state ${!savedConditions[index - 1]?.checkedStoreLabels?.length > 0
                                                    ? 'justify-content-center align-items-center'
                                                    : ''
                                                    }`}
                                            >
                                                {savedConditions[index - 1]?.checkedStoreLabels?.length > 0 ? (
                                                    savedConditions[index - 1]?.checkedStoreLabels?.map((item, id) => (
                                                        <li key={`condition-${id}`}>{item}</li>
                                                    ))
                                                ) : (
                                                    <li>검색조건 없습니다</li>
                                                )}
                                            </ul>
                                        )}
                                    </div>
                                    <div id="content-table">
                                        <div className="container">
                                            <div className="wrap-table">
                                                <div className="header-table-container mt-2">
                                                    <div
                                                        className="table table-header table-results"
                                                        style={{
                                                            gridTemplateColumns: 'calc(100% - 22% - 13%) 22% 13%',
                                                        }}
                                                    >
                                                        <div className="column column-1">제목</div>
                                                        <div className="column column-2">경력/형태/자격증</div>
                                                        <div className="column column-3">수정</div>
                                                    </div>
                                                </div>
                                                <ul className="table table-has-more-infomation PAJAF010">
                                                    {condition === 0 ? (
                                                        resultsStTab &&
                                                        resultsStTab?.length > 0 &&
                                                        resultsStTab?.map((item, idx) => {
                                                            return (
                                                                <ResumeItem
                                                                    key={idx}
                                                                    item={item}
                                                                    hasDelete={false}
                                                                    setResumeList={setResultsStTab}
                                                                    showStar={true}
                                                                    showEnvelope={true}
                                                                    setPopupSendMailOpen={setPopupSendMailOpen}
                                                                    setReceiver={setReceiver}
                                                                    roleAction="C"
                                                                    detailUrl="myPage"
                                                                />
                                                            );
                                                        })
                                                    ) : !isFilter &&
                                                        savedConditions[index - 1] &&
                                                        results &&
                                                        results?.length > 0 ? (
                                                        results?.map((item, idx) => {
                                                            return (
                                                                <ResumeItem
                                                                    key={idx}
                                                                    item={item}
                                                                    setResumeList={setResults}
                                                                    showEnvelope={true}
                                                                    showStar={true}
                                                                    setPopupSendMailOpen={setPopupSendMailOpen}
                                                                    setReceiver={setReceiver}
                                                                    roleAction="C"
                                                                    detailUrl="myPage"
                                                                />
                                                            );
                                                        })
                                                    ) : (
                                                        <div className="no-data">
                                                            {loading ? (
                                                                <p>
                                                                    <Loader size={30} color="#0068b7" />
                                                                </p>
                                                            ) : (
                                                                '등록된 이력서가 없습니다.'
                                                            )}
                                                        </div>
                                                    )}
                                                    {condition === 0 && !resultsStTab && !resultsStTab?.length > 0 && (
                                                        <div className="no-data">
                                                            {loading ? (
                                                                <p>
                                                                    <Loader size={30} color="#0068b7" />
                                                                </p>
                                                            ) : (
                                                                '등록된 이력서가 없습니다.'
                                                            )}
                                                        </div>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    {/* savedConditions[index - 1] nếu tab nào k có điều kiện tìm kiếm thì k cho hiện page */}
                                    {isFilter && condition === 0 && savedConditions[index - 1] && (
                                        <Pagination pages={pagesFirstTab} params={'pageSt'} />
                                    )}
                                    {!isFilter && condition !== 0 && savedConditions[index - 1] && (
                                        <Pagination pages={pages} params={'page'} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {activePopup && <PopupPAJAF010 onClose={handlePopupClose} decode={decode} indexActive={index} />}
            {popupSendMailOpen && <PopupSendMail closePopup={closePopup} receiver={receiver} />}
        </>
    );
};

export default PAJAF010;
